import classNames from "classnames";

import { useSelector } from "@/redux/hooks";
import { getDispensaryState } from "@/redux/selectors/cartDispensary";
import { getIsDefaultLocation, getState } from "@/redux/selectors/location";

import Prop65Icon from "@/components/Icons/prop65_warning.svg";

const Prop65Message: React.FC<{ className?: string }> = ({ className }) => {
  const userState: string | null = useSelector(getState);
  const isDefaultLocation = useSelector(getIsDefaultLocation);
  const hasState = userState && userState !== "";
  const dispensaryState = useSelector(getDispensaryState);
  const isCalifornia: boolean =
    userState === "California" || dispensaryState === "CA";

  return !hasState || isDefaultLocation || isCalifornia ? (
    <div
      className={classNames(
        className,
        "flex px-lg py-sm rounded border border-light-grey",
      )}
      data-testid="prop65-message"
    >
      <Prop65Icon height="20" width="22" className="mr-sm flex-shrink-0" />
      <span className="text-xs text-grey ">
        <b>WARNING:</b> <em>Cancer and Reproductive Harm</em> -{" "}
        <a
          href="https://www.P65Warnings.ca.gov"
          className="font-bold underline"
          target="_blank"
          rel="noreferrer"
        >
          www.P65Warnings.ca.gov
        </a>
        .
      </span>
    </div>
  ) : null;
};

export default Prop65Message;
